import { formatThaiCurrency } from '../utils';

interface FilterHandlersProps {
  setLocationAnchorEl: (anchor: HTMLElement | null) => void;
  setPriceMin: (price: number) => void;
  setPriceMax: (price: number) => void;
  setMinInputValue: (value: string) => void;
  setMaxInputValue: (value: string) => void;
  setSelectedBedrooms: (bedroom: string | null) => void;
  setSelectedBathrooms: (bathroom: string | null) => void;
  setSelectedQuota: (quota: string | null) => void;
  setSelectedStatus: (status: string | null) => void;
  setSelectedFloor: (floor: string | null) => void;
  setSelectedPublishedBy: (publishedBy: string | null) => void;
  setSelectedPostedDate: (postedDate: string | null) => void;
  setSelectedView: (view: string | null) => void;
  setSelectedDirection: (direction: string | null) => void;
  
  setAreaMin: (area: number) => void;
  setAreaMax: (area: number) => void;
  setAreaMinInput: (value: string) => void;
  setAreaMaxInput: (value: string) => void;

  priceMin: number;
  priceMax: number;
  areaMin: number;
  areaMax: number;
  
  onSearch?: () => void;
}

const formatNumberWithCommas = (value: string): string => {
  const numericValue = value.replace(/[^0-9]/g, '');
  if (!numericValue) return '';
  return Number(numericValue).toLocaleString();
};

export const createFilterHandlers = (props: FilterHandlersProps) => {
  const handleLocationOpen = (event: React.MouseEvent<HTMLElement>) => {
    props.setLocationAnchorEl(event.currentTarget);
  };

  const handleLocationClose = () => {
    props.setLocationAnchorEl(null);
  };

  const handleMinPriceSelect = (price: number) => {
    props.setPriceMin(price);
    props.setMinInputValue(formatThaiCurrency(price));
  };

  const handleMaxPriceSelect = (price: number) => {
    props.setPriceMax(price);
    props.setMaxInputValue(formatThaiCurrency(price));
  };

  const handleMinInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, '');
    const formattedValue = formatNumberWithCommas(rawValue);
    props.setMinInputValue(formattedValue);
    props.setPriceMin(Number(rawValue) || 0);
  };

  const handleMaxInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, '');
    const formattedValue = formatNumberWithCommas(rawValue);
    props.setMaxInputValue(formattedValue);
    props.setPriceMax(Number(rawValue) || 0);
  };

  const handleAreaMinSelect = (area: number) => {
    props.setAreaMin(area);
    props.setAreaMinInput(formatThaiCurrency(area));
  };

  const handleAreaMaxSelect = (area: number) => {
    props.setAreaMax(area);
    props.setAreaMaxInput(formatThaiCurrency(area));
  };

  const handleAreaMinInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, '');
    const formattedValue = formatNumberWithCommas(rawValue);
    props.setAreaMinInput(formattedValue);
    props.setAreaMin(Number(rawValue) || 0);
  };

  const handleAreaMaxInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, '');
    const formattedValue = formatNumberWithCommas(rawValue);
    props.setAreaMaxInput(formattedValue);
    props.setAreaMax(Number(rawValue) || 0);
  };

  const handleFilterApply = () => {
  };

  const handleFilterReset = () => {
    props.setPriceMin(0);
    props.setPriceMax(1000000000);
    props.setMinInputValue('0');
    props.setMaxInputValue('1,000,000,000');
    props.setSelectedBedrooms(null);
    props.setSelectedBathrooms(null);
    props.setSelectedQuota(null);
    props.setSelectedStatus(null);
    props.setSelectedFloor(null);
    props.setSelectedPublishedBy(null);
    props.setSelectedPostedDate(null);
    props.setSelectedView(null);
    props.setSelectedDirection(null);
    props.setAreaMin(0);
    props.setAreaMax(1000);
    props.setAreaMinInput('0');
    props.setAreaMaxInput('1,000');
  };

  return {
    handleLocationOpen,
    handleLocationClose,
    handleMinPriceSelect,
    handleMaxPriceSelect,
    handleMinInputChange,
    handleMaxInputChange,
    handleAreaMinSelect,
    handleAreaMaxSelect,
    handleAreaMinInputChange,
    handleAreaMaxInputChange,
    handleFilterApply,
    handleFilterReset
  };
}; 